/**
 * 考核内容内嵌表单
 * @author wutao
 * @date 2020-08-31
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { Col } from 'antd'
import { framework_tool, component_tool } from '@/tool'
let { WizContainer } = framework_tool;
let { WizForm, WizButton } = component_tool;

class CommentDetailForm extends WizContainer {

  componentName = 'commentDetailForm';

  static propTypes = {
    addCommentDetail: PropTypes.func,
    commentDetailData: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }


  /** 添加考核内容 */
  _addItem() {
    let { addCommentDetail,item,maxSort } = this.props;
    if (this.refs.commentDetailForm && this.refs.commentDetailForm.validateFields) {
      this.refs.commentDetailForm.validateFields((err, values) => {
        if (!err) {
          if (addCommentDetail) {
            if (item && item.key) {
              values.key = item.key;
              values.update = true;
            }else {
              values.key = new Date().getTime() + '_commentDetail';
            }
            if(item && item.state !== values.state && values.state===0){
              values.tips = true
            }
            addCommentDetail(values);
            this.refs.commentDetailForm.setFieldsValue({ head: '', state: 1 })
          }
          values.updateTime = new Date();
        }
        return
      });
    }
  }

  validateNameRepeat = (rule, value, callback) => {
    let { commentDetailData, item } = this.props;
    commentDetailData.forEach((data, index) => {
      if (data.head === value && !item){
        callback('名称已存在');
      }else if (data.head === value && (item && item.key != data.key)) {
        callback('名称已存在');
      }
    });
    callback();
  }


  _render() {
    const columns = [
      {
        name: "id",
        formItem: {
          type: "hidden",
          initialValue: this.props.item && this.props.item.id ? this.props.item.id : null
        }
      },
      {
        name: "sort",
        formItem: {
          type: "hidden",
          initialValue: this.props.item && this.props.item.sort ? this.props.item.sort : this.props.maxSort+1
        }
      },
      {
        title: "考核内容",
        name: "head",
        dataIndex: "head",
        formItem: {
          maxlength: 50,
          placeholder: '考核内容名称最多输入50个字',
          rules: [{
            required: true,
            message: '请输入考核内容名称',
          },
            { validator: this.validateNameRepeat }
          ],
          initialValue: this.props.item && this.props.item.head ? this.props.item.head : null
        },
      },
      {
        title: '状态',
        name: 'state',
        dataIndex: 'state',
        formItem: {
          type: 'Radio',
          rules: [{
            required: true,
            message: '请选择状态',
          }],
          initialValue: this.props.item && (this.props.item.state||this.props.item.state==0) ? this.props.item.state : 1
        },
        dict: [
          { code: 1, codeName: "有效" },
          { code: 0, codeName: "无效" }
        ],
      }
    ]

    let onSubmit = this._addItem.bind(this);

    let formProps = {
      ref: 'commentDetailForm',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: <Col className="form-btns col-item"><WizButton type="primary" onClick={this._addItem.bind(this)}>保存</WizButton></Col>,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      style: { width: '100%' }
    }

    return (
      <WizForm key='commentDetailForm' className={'form-inline'} {...formProps} />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(CommentDetailForm);
